/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_EyebrowInputs */

const en_directory_hubs_eyebrow = /** @type {(inputs: Directory_Hubs_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community discovery`)
};

const zh_directory_hubs_eyebrow = /** @type {(inputs: Directory_Hubs_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区发现`)
};

/**
* | output |
* | --- |
* | "Community discovery" |
*
* @param {Directory_Hubs_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_eyebrow = /** @type {((inputs?: Directory_Hubs_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_eyebrow(inputs)
	return zh_directory_hubs_eyebrow(inputs)
});
export { directory_hubs_eyebrow as "directory.hubs.eyebrow" }